<template>
	<div class="ca-services">

		<h3 class="title title-page text-primary font-medium">Prestations</h3>

		<div class="md-layout md-gutter">
			<div class="md-layout-item md-size-100">
				<md-card>
					<md-card-header class="md-card-header-icon md-card-header-blue">
						<div class="card-icon">
							<font-awesome-icon class="md-icon" :icon="['fa', 'layer-group']" />
						</div>
						<h4 class="title font-normal">Liste des prestations</h4>
					</md-card-header>
					<md-card-content>
						<div class="services-site mb-6" v-for="(site) in sites" :key="site.id">
							<h5 class="text-info font-medium mb-1" v-if="site.name">{{ site.name }}</h5>

							<div class="relative">
								<div class="services pl-5">
									<div class="mt-1 mb-2">
										<h4 class="font-medium text-base mb-0">Plans de localisation des dispositifs de prévention contre les nuisibles</h4>
										<md-list class="md-dense" v-if="site.documents.length > 0">
											<md-list-item v-for="plan in site.documents" :key="plan.id" class="ml-0 mb-0">
												<div class="flex items-center space-x-2">
													<plan-button-pdf :plan-id="plan.id" is-from-client-area></plan-button-pdf>
													<span class="font-light">{{ plan.name }}</span>
												</div>
											</md-list-item>
										</md-list>
										<span v-else>Aucun plan disponible pour ce site</span>
									</div>

									<md-divider class="mb-3" v-if="site.documents.length > 0 && site.planning.length > 0"></md-divider>

									<div class="mt-1">
										<div v-for="interventionGroup in site.planning" :key="interventionGroup.id" style="margin-bottom: .5rem;">
											<p class="font-medium text-base mb-0 leading-4">{{ interventionGroup.intervention_type.name }}</p>
											<span>{{ formatMonths(interventionGroup.planning_intervention_previsions) }}</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</md-card-content>
				</md-card>
			</div>
		</div>

	</div>
</template>

<script>
import PlanButtonPdf from "../../Sites/Devices/Plans/components/PlanButtonPdf"

export default {
	name: "ClientsAreaServices",
	components: { PlanButtonPdf },
	data() {
		return {
			sites: [],
		}
	},
    mounted () {
        this.fetchServices()
    },
	methods: {
        async fetchServices() {
            const localStorageData = JSON.parse(localStorage.getItem('client-area'))
            const { data } = await this.$store.dispatch('clientArea/fetchServices', {
                    access_token: localStorageData.accessToken,
                    user_type: localStorageData.userType,
                });
            this.sites = data
        },
		formatMonths(previsions) {
            let months = new Set(previsions.map(o => o.month_label))
			return Array.from(months).join(' - ')
		},
	},
	computed: {
		sitesName() {
			return this.sites.map(site => { return site.name ?? '' })
		}
	}
}
</script>

<style scoped lang="scss">
.services-site {
	&:last-child {
		margin-bottom: 0 !important;
	}
}
</style>
